

const pointValues = {
    NORMAL: 1,
    SLOW: 3,
    TRAFFIC_JAM: 6
  };

const calculateTrafficScore = (data) => {
    const result = {
        totalScore: 0,
        breakdown: {}
      };
    
      data.forEach(segment => {
        const { startPolylinePointIndex, endPolylinePointIndex, speed } = segment;
        const segmentLength = endPolylinePointIndex - startPolylinePointIndex + 1;
        const segmentScore = segmentLength * pointValues[speed];
    
        // Genel toplam puan
        result.totalScore += segmentScore;
    
        // Trafik tipi bazında gruplandırma
        if (!result.breakdown[speed]) {
          result.breakdown[speed] = 0;
        }
        result.breakdown[speed] += segmentScore;
      });
      
    
      return result;
}

export default calculateTrafficScore